<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60"><circle cx="30" cy="30" r="30" style="fill:#2c59d9"/><g><path d="m20442 3936 7.271-10.5-7.271-10.5h18l-7.27 10.5 7.27 10.5z" style="fill:none;stroke:#fff;stroke-linejoin:round;stroke-width:2px" transform="translate(-20421 -3895.75)" fill="currentColor"/><path d="M2 0h8L7.082 4.354H4.988z" style="fill:#fff" transform="translate(24 25.75)" fill="currentColor"/><path d="M0 6h18l-4.775-6H5z" style="fill:#fff" transform="translate(21 34.75)" fill="currentColor"/></g></svg>
</template>
<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'ri-free-time',
});
</script>
